<script setup lang="ts">
  import { MpButton, MpCard, MpDivider, MpText, useMpScreen } from '@borg/ui';

  defineEmits<{
    (event: 'next'): void;
  }>();

  const { isMobile } = useMpScreen();
  const applicationForm = _applicationForm.inject();
  const inProgress = computed(
    () =>
      applicationForm.saveStatus === 'inProgress' ||
      applicationForm.startVerificationStatus === 'inProgress',
  );
</script>

<template>
  <MpCard
    p="lg"
    border
    shadow
  >
    <MpText
      as="h5"
      no-margin
      uppercase
    >
      {{ $t('JOB_APPLICATION_OVERVIEW_PAGE.TITLE') }}
    </MpText>
    <MpDivider />
    <JobApplicationOverview
      v-if="applicationForm.application"
      :application="applicationForm.application"
    />
  </MpCard>
  <JobActionsBar>
    <MpButton
      test="application-overview-send-application-button"
      :text="$t('JOB_APPLICATION_OVERVIEW_PAGE.SEND_APPLICATION_BUTTON_LABEL')"
      :is-full-width="isMobile"
      :is-loading="inProgress"
      :disabled="inProgress"
      @click="$emit('next')"
    />
  </JobActionsBar>
</template>

<style scoped lang="scss">
  .v-enter-active,
  .v-leave-active {
    transition: all 250ms ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
</style>
